import { Component, OnInit } from '@angular/core';
import { PacienteService } from 'src/app/services/paciente.service';

@Component({
  selector: 'app-menu-expediente-clinico',
  templateUrl: './menu-expediente-clinico.component.html',
  styles: []
})
export class MenuExpedienteClinicoComponent implements OnInit {

  constructor(
    public _pacienteSrv: PacienteService,
  ) { }

  ngOnInit() {
  }

}
